import classNames from 'classnames';

interface WhiskyAndIceLoadingFallbackProps {
  overlay?: boolean;
}
export default function WhiskyAndIceLoadingFallback({
  overlay,
}: WhiskyAndIceLoadingFallbackProps) {
  return (
    <div className={classNames('page-loader', {overlay})} id="page-loader">
      <div className="whiskey-loader">
        <svg
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="65px"
          height="65px"
          viewBox="0 0 53.116 55.012"
          enableBackground="new 0 0 53.116 55.012"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fill="#EF4223"
              fillOpacity="0.8"
              d="M3.605,26.535c-1.268,8.396-1.329,9.548-0.413,13.635c1.854,8.263,9.813,12.451,23.661,12.451   c14.216,0,21.405-3.84,23.311-12.448c0.907-4.101,0.818-5.27-0.446-13.667C35.754,31.807,17.573,31.817,3.605,26.535z"
            />
          </g>
          <g>
            <path
              fill="#dadada"
              d="M48.887,6.826c-0.484-1.881-1.437-3.445-7.188-4.632C37.658,1.36,26.782-0.728,11.746,2.1   C7.289,2.938,5.039,4.531,4.94,6.248C4.662,7.78,0.02,33.516,1.592,40.53c2.053,9.16,10.582,13.815,25.353,13.815   c14.973,0,22.917-4.702,25.002-14.123C53.514,33.138,49.318,8.493,48.887,6.826 M26.766,2.491c13.009,0,20.104,2.586,20.104,3.915   c0,1.328-7.096,3.915-20.104,3.915c-13.008,0-20.103-2.587-20.103-3.915C6.663,5.077,13.758,2.491,26.766,2.491 M50.253,40.172   c-1.904,8.609-9.094,12.449-23.31,12.449c-13.849,0-21.811-4.189-23.66-12.451C2.017,34.524,5.205,14.919,6.299,8.565   c1.126,0.803,2.943,1.495,5.446,2.065c4.021,0.918,9.355,1.422,15.021,1.422s10.998-0.504,15.021-1.422   c2.505-0.571,4.323-1.262,5.449-2.067C48.327,14.913,51.506,34.515,50.253,40.172"
            />
          </g>
        </svg>
        <div className="icecube" />
        <div className="icecube" />
      </div>
    </div>
  );
}
